export default "__VITE_ASSET__kgJh1WBD__"